var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(
            _vm._s(_vm.$t("routeBusinessStockDeliveryResultView.Basic")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Delivery"
                        ),
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.data.resultCode) + " "),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.resultCode },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Outbound"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.outLogicWarehouseCode) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Name"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.outLogicWarehouseName) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Logistics"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.logisticCompany) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.business"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.logisticBusiness) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Consignee"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "receiverNameMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["receiverNameMask"],
                          "order-sn": _vm.data.orderCode,
                          inner: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Contact"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "receiverPhoneMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["receiverPhoneMask"],
                          "order-sn": _vm.data.orderCode,
                          inner: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Shipping"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "addressMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["addressMask"],
                          "order-sn": _vm.data.orderCode,
                          inner: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Creation"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.creationDate) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryResultView.Created"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.createdName) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("routeBusinessStockDeliveryResultView.Associated"))
        ),
      ]),
      _c(
        "el-form",
        { attrs: { inline: "" } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryResultView.Doc"),
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.data.shippingNo) + " "),
                  _vm.data.shippingNo
                    ? _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.shippingNo },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryResultView.notice"
                    ),
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.$toPage(
                            "BusinessStockDeliveryInformView",
                            { id: _vm.data.odoId }
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.data.odoCode))]
                  ),
                  _vm.data.odoCode
                    ? _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.odoCode },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryResultView.WMS"),
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.data.wmsCode) + " "),
                  _vm.data.wmsCode
                    ? _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.odowmsCodeCode },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("routeBusinessStockDeliveryResultView.Product"))),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          serial: _vm.serial,
          selection: false,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "row-key": "id",
          "no-auto-height": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "startBtnGroup",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryResultView.SKU"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryResultView.SKUcode"
                    ),
                    prop: "skuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryResultView.Quantity"
                    ),
                    prop: "realNum",
                    align: "center",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationLeft",
            fn: function () {
              return [
                _c("span", { staticClass: "ml20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("routeBusinessStockDeliveryResultView.Shipped")
                    ) + _vm._s(_vm.qtyData.alreadyOutQty)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }